import React from "react";
// import { useTranslation } from "react-i18next";
// import { landingApi } from "../api/landingApi";
import { useAuth } from "./AuthContext";
import { useNavigate } from "react-router-dom";

export default function Packages() {
  // const { t } = useTranslation();
  // `useAuth` values are not currently used in this component.
  // Keep auth hook for future needs, but avoid unused-variable ESLint errors.
  useAuth();
  const navigate = useNavigate();

  const handleNormalSubmit = async (e) => {
    e.preventDefault();

    localStorage.removeItem("planId");
    localStorage.removeItem("oneTime");
    localStorage.removeItem("amount");

    localStorage.setItem("planId", 2);
    localStorage.setItem("oneTime", 0);
    localStorage.setItem("amount", 350000);

    navigate("/paymentTransitions");
  };

  const handleBusinessSubmit = async (e) => {
    e.preventDefault();

    localStorage.removeItem("planId");
    localStorage.removeItem("oneTime");
    localStorage.removeItem("amount");

    localStorage.setItem("planId", 3);
    localStorage.setItem("oneTime", 1);
    localStorage.setItem("amount", 600000);

    navigate("/paymentTransitions");
  };

  return (
    <>
      <div className="flex px-20 gap-3 my-0" id="zayverse-content">
        {/* <div
          className="border absolute top-[120px] flex w-1/3 space-y-4 flex-col px-10 py-5 pb-8 shadow-lg rounded-xl bg-white"
          id="left-div"
        >
          <h2 className="text-2xl text-center mt-3 font-bold">
            Normal Package
          </h2>
          <p className="font-semibold text-center">
            {t("oneTimePurchaseLifetimeAccess")}
          </p>
          <p className="text-gray-500">{t("basicPackageDescription")}</p>
          <div className="flex gap-1 items-center font-semibold">
            <h3 className="text-xl">350,000 MMK</h3>
            <p>24 months</p>
          </div>
          <p className="text-gray-500">{t("perLocation")}</p>
          <div className="flex justify-center">
            <button className="border hover:bg-gray-100 hover:shadow-lg mb-5 rounded-md px-20 py-1 border-black">
              {t("getStarted")}
            </button>
          </div>
          <div className="bg-gray-200 p-2 flex gap-5 items-center rounded-md">
            <House />
            <p>{t("completeShopProfile")}</p>
          </div>
          <div className="bg-gray-200 p-2 flex gap-5 items-center rounded-md">
            <MapPin />
            <p>{t("smartVisibility")}</p>
          </div>
          <div className="bg-gray-200 p-2 flex gap-5 items-center rounded-md">
            <ThumbsUp />
            <p>{t("socialEngagement")}</p>
          </div>
          <div className="bg-gray-200 p-2 flex gap-5 items-center rounded-md">
            <Users />
            <p>{t("customerConnection")}</p>
          </div>
          <div className="bg-gray-200 p-2 flex gap-5 items-center rounded-md">
            <Megaphone />
            <p>{t("promotionalPower")}</p>
          </div>
          <div className="bg-gray-200 p-2 flex gap-5 items-center rounded-md">
            <ChartLine />
            <p>{t("simpleDashboard")}</p>
          </div>
          <div className="bg-gray-200 p-2 flex gap-5 items-center rounded-md">
            <QrCode />
            <p>{t("menuQrCode")}</p>
          </div>
          <div className="bg-gray-200 p-2 flex gap-5 items-center rounded-md">
            <MonitorSmartphone />
            <p>{t("multiDeviceAccess")}</p>
          </div>
        </div> */}

        {/* <div
          className="border p-5 rounded-lg ml-auto shadow-lg flex w-3/5 justify-center gap-0 py-10 pb-20 mt-5"
          id="right-div"
        >
          <div className="flex flex-1 flex-col text-center">
            <p className="text-gray-300 mb-10">{t("zayverseExclusive")}</p>
            <h2 className="text-lg font-bold mb-5">{t("getCustomPricing")}</h2>
            <button
              type="button"
              className="bg-[#1E2749] w-3/5 mx-auto text-white px-5 py-2 rounded-lg hover:bg-orange-500 transition hover:text-black font-semibold cursor-pointer"
            >
              {t("talkToOurTeam")}
            </button>
          </div>
          <div className="flex flex-1 flex-col justify-center space-y-10">
            <p className="text-sm">
              {t("managingMultipleLocationsDescription")}
            </p>
            <p className="text-sm">{t("talkToTeamDescription")}</p>
          </div>
        </div> */}

        <div className="bg-white flex absolute border top-40 w-5/12 left-10">
          <div className="border px-5 py-3 flex-1 border-black mx-3 my-2">
            <h1>Normal Package</h1>
            <h2>Price 350,000</h2>
            <p>one time usage</p>
            <p>24 months</p>
            <button
              className=" custom-darkblue-button custom-shadow-effect my-5"
              type="button"
              onClick={handleNormalSubmit}
            >
              Get Started
            </button>
          </div>
          <div className="border px-5 py-3 flex-1 border-black mx-3 my-2">
            <h1>Business Package</h1>
            <h2>Price 600,000</h2>
            <p>lift time useage</p>
            <p>24 months</p>
            <button
              className=" custom-darkblue-button custom-shadow-effect my-5"
              type="button"
              onClick={handleBusinessSubmit}
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
